export default __webpack_public_path__ + "static/media/portada_Panel01_ENG.1bce6875.jpg";